import { createContext, useContext, useState } from "react";

export const interviewSteps = [
  "main",
  "profilePicture",
  "faceCalibration",
  "startInterview",
  "mcqs",
  "oralQuestions",
  "codingQuestions",
  "completed",
  "reportGenerated"
];

const InterviewContext = createContext();

export const InterviewProvider = ({ children }) => {
  const [currentStep, setCurrentStep] = useState("main");

  // New: State to hold data collected during interview
  const [interviewData, setInterviewData] = useState({});

  /**
   * Move to next step (optional: with data)
   * @param {*} data
   */
  const nextStep = (data = {}) => {
    setInterviewData((prev) => ({ ...prev, ...data }));
    const currentIndex = interviewSteps.indexOf(currentStep);
    if (currentIndex < interviewSteps.length - 1) {
      setCurrentStep(interviewSteps[currentIndex + 1]);
    }
  };

  /**
   * Jump to any step with data
   * @param {*} step
   * @param {*} data
   */
  const goToStep = (step, data = {}) => {
    if (interviewSteps.includes(step)) {
      setInterviewData((prev) => ({ ...prev, ...data }));
      setCurrentStep(step);
    }
  };

  return (
    <InterviewContext.Provider
      value={{
        currentStep,
        setCurrentStep,
        nextStep,
        goToStep,
        interviewData,
        setInterviewData,
      }}
    >
      {children}
    </InterviewContext.Provider>
  );
};

export const useInterview = () => useContext(InterviewContext);
